import axios from "axios";
import Globals from "../Globals";
import ParseService from "./ParseService";

class LoggingService {
  base_url = Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.LOG.BASE_PATH;

  createLog = async (token, options) => {
    //Error(options)
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ErrorCode: Globals.ERROR_CODE,
      },
      body: JSON.stringify(""),
    };
    return axios
      .post(
        this.base_url + Globals.BFF_PATH.LOG.CREATE,
        new ParseService().TransformToAWS(options),
        config
      )
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        //Error
      });
  };
}

export default LoggingService;
